import { PecSwitch, PrivateRoute } from 'components/route'
import { RELATORIOS_BI_ATENDIMENTO_ENABLED } from 'config/flags'
import React from 'react'
import { useRouteMatch } from 'react-router'
import Permissions from 'types/Permissions'

import { AbsenteismoView } from './absenteismo/AbsenteismoView'
import { AtendimentosProfissionalView } from './atendimentos/AtendimentosProfissioaisView'

export function BiRootView(props: any) {
  const { path } = useRouteMatch()

  return (
    <>
      <PecSwitch>
        {RELATORIOS_BI_ATENDIMENTO_ENABLED && (
          <PrivateRoute exact path={`${path}/atendimentos`} permission={Permissions.relatorios.gerenciais.atendimentos}>
            <AtendimentosProfissionalView />
          </PrivateRoute>
        )}
        <PrivateRoute exact path={`${path}/absenteismo`} permission={Permissions.relatorios.gerenciais.absenteismo}>
          <AbsenteismoView />
        </PrivateRoute>
      </PecSwitch>
    </>
  )
}
